import { PROGRAM_INVOICE_TYPE } from '@hopdrive/sdk-ar';

/**
 * Whether an invoice bills through AR charges rather than the old armove rows.
 * The invoice page, its PDF and its CSVs all decide by this, so a program
 * invoice that shows its charges on screen also downloads them.
 */
export const isChargeBasedInvoiceType = (invoiceType?: string | null): boolean =>
  !!invoiceType && (invoiceType.endsWith('_charges') || invoiceType === PROGRAM_INVOICE_TYPE);
